import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { lensPath, findIndex, propEq, curry, set } from 'ramda'
import client from '@/ports/api-client'
import queryClient from '@/components/query-client'
import { toast } from '@/components/toast-notifications'

const useFavouriteTrustScore = ({
  currentTab,
  searchString,
  page,
  limit
}: {
  currentTab: string
  searchString: string
  page: number
  limit: number
}) => {
  const oldData = queryClient.getQueryData([
    'trustScoreList',
    currentTab,
    searchString,
    page,
    limit
  ])

  const { t } = useTranslation()

  const mutation = useMutation({
    mutationFn: ({ id, name }: { id: number; name: string }) => {
      const response = client.put(`/trust_score/standalone/${id}/favourite`)
      return response
    },
    onSuccess: async (response: { is_favourite: boolean }, variables) => {
      const favouriteLens = curry((key, id, data) =>
        lensPath(['items', findIndex(propEq('id', id))(data.items), 'favourite'])
      )
      const replaceFavourite = favouriteLens(0, variables.id, oldData)
      const result = set(replaceFavourite, response?.is_favourite, oldData)

      queryClient.setQueryData(['trustScoreList', currentTab, searchString, page, limit], result)

      toast('', {
        title: `${
          !response?.is_favourite
            ? t(
                'l.standalone.view.remove_from_favourites.title',
                'Trust Score removed from favourites!'
              )
            : t(
                'l.standalone.view.add_to_favourites_success.title',
                'Trust Score added to favourites!'
              )
        }`,
        type: 'success'
      })
    }
  })
  return mutation
}

export default useFavouriteTrustScore
